module.exports = __webpack_public_path__ + "img/346c9a8.png";